import React, { useEffect } from "react";
import "./Applications.css";
import AOS from "aos";
import "aos/dist/aos.css";

import SocialMedia from "./social.png";
import BillingSystem from "./billing.png";

const applicationData = [
   {
      id: 1,
      title: "Social Media Web Application",
      image: SocialMedia,
      appLink: "https://social-media-web-application-fe.onrender.com",
   },
   {
      id: 2,
      title: "Billing System",
      image: BillingSystem,
      appLink: "https://asarpexlab-billing-system.netlify.app/",

   },
];

const Applications = () => {
   useEffect(() => {
      document.title = "Applications | Amresh Kumar";

      const metaDescription = document.querySelector(
         'meta[name="description"]'
      );

      if (metaDescription) {
         metaDescription.setAttribute(
            "content",
            "Explore full-stack web applications built by Amresh Kumar using React.js, Node.js, Django and modern web technologies."
         );
      }

      AOS.init({
         duration: 700,
         once: false,
         mirror: true,
         easing: "ease-in-out",
      });
   }, []);

   return (
      <div className="applications-main">

         <div className="applications-show">

            {applicationData.map((application) => (
               <div
                  className="application-card"
                  key={application.id}
               >

                  {/* Image Clickable */}
                  <a
                     href={application.appLink}
                     target="_blank"
                     rel="noreferrer"
                     className="application-image-link"
                  >
                     <img
                        src={application.image}
                        alt={application.title}
                        className="application-image"
                        data-aos="zoom-in-up"
                        data-aos-duration="1000"
                     />
                  </a>

                  {/* Title */}
                  <div
                     className="application-title"
                     data-aos="fade-up"
                     data-aos-duration="1000"
                  >
                     <h2>{application.title}</h2>
                  </div>

               
               </div>
            ))}

         </div>

      </div>
   );
};

export default Applications;